<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'

  export default {
    name: 'CartEmail',
    props: {
      index: Number,
      invalid: Boolean,
      isTabActive: Boolean,
      showEmail: Boolean,
      validated: Boolean,
    },
    data() {
      return {
        timer: null,
      }
    },
    computed: {
      ...mapState('invoiceAddress', ['invoiceAddress']),
      ...mapFields('invoiceAddress', ['invoiceAddress.email']),
    },
    methods: {
      ...mapActions('invoiceAddress', ['updateAddress']),
      saveAddress() {
        clearTimeout(this.timer)
        this.timer = setTimeout(_ => {
          this.updateAddress({
            ...this.invoiceAdress,
          })
        }, 750)
      },
    },
  }
</script>
